import { render, staticRenderFns } from "./quiz.html?vue&type=template&id=783b8ad8&scoped=true&"
import script from "./quiz.js?vue&type=script&lang=js&"
export * from "./quiz.js?vue&type=script&lang=js&"
import style0 from "./quiz.scss?vue&type=style&index=0&id=783b8ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b8ad8",
  null
  
)

export default component.exports